import { render, staticRenderFns } from "./DeleteQuizDialog.vue?vue&type=template&id=5ee51cd0&scoped=true"
import script from "./DeleteQuizDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuizDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteQuizDialog.vue?vue&type=style&index=0&id=5ee51cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee51cd0",
  null
  
)

export default component.exports